<div
  class="ds-label"
  [class.ds-label--has-label]="labelSg()?.length"
>
  @if (labelSg()) {
    <div class="ds-label__title">
      <div class="ds-label__title-left-segment">
        <span>{{ labelSg() }}</span>
        @if (loadingSg()) {
          <div class="ds-label__title-loader-wrapper">
            <div class="ds-label__title-loader"></div>
          </div>
        }
      </div>
      <div>
        <ng-content select="[extra]" />
      </div>
    </div>
  }

  <!-- ------------------------------- Content ------------------------------- -->
  <div class="ds-label__content">
    <ng-content />
  </div>
</div>
